import { api } from "./api";

const quotationmainApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getQuotations: builder.query({
      query: () => "quotation-main",
      providesTags: ["quotation-main"],
    }),
    addQuotation: builder.mutation({
      query: (newCategory) => ({
        url: "quotation-main",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["quotation-main"],
    }),
    removeQuotation: builder.mutation({
      query: (id) => ({
        // url: `orders2/${id}`,
        url: `quotation-mains?qto_no=${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["quotation-main"],
    }),
    editQuotation: builder.mutation({
      query: (editData) => ({
        url: `quotation-main`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["quotation-main"],
    }),
  }),
});

export const {
  useGetQuotationsQuery,
  useAddQuotationMutation,
  useRemoveQuotationMutation,
  useEditQuotationMutation,
} = quotationmainApi;
